import React from 'react';
import { LockIcon, ThumbsUpIcon } from 'lucide-react';
import { comments } from '../data/comments';
export function CommentsSection() {
  return <section aria-labelledby="comentarios-titulo" className="border-t border-neutral-200 pt-8" data-id="element-108" data-mp="18x1wkni03pqu">
      <div className="flex items-baseline justify-between gap-4" data-id="element-109" data-mp="1dukaksavkv5p">
        <h2 id="comentarios-titulo" className="font-sans text-xl font-bold text-ink" data-id="element-110" data-mp="1inn4j1jke6mf">
          Comentarios (124)
        </h2>
        <span className="font-sans text-xs text-ink-muted" data-id="element-111" data-mp="1nlew1ugarqq3">Ordenar por: Más relevantes</span>
      </div>

      <div className="mt-5 flex items-center gap-3 rounded-sm border border-neutral-200 bg-neutral-50 px-4 py-3" aria-hidden="true" data-id="element-112" data-mp="1siybgxoqe9jm">
        <span className="h-9 w-9 shrink-0 rounded-full bg-neutral-300" data-id="element-113" data-mp="21lppn58zrjey" />
        <span className="font-sans text-sm text-ink-muted" data-id="element-114" data-mp="28d999593mw8">Escribe un comentario…</span>
        <span className="ml-auto flex items-center gap-1.5 font-sans text-[0.7rem] font-semibold uppercase tracking-wide text-ink-muted" data-id="element-115" data-mp="2apy869fexis">
          <LockIcon className="h-3.5 w-3.5" data-id="element-116" data-mp="ha5syzn7eder" />
          Cerrado
        </span>
      </div>
      <p className="mt-2 font-sans text-xs text-ink-muted" data-id="element-117" data-mp="cint6ewx2ivd">
        Los comentarios de este artículo han sido cerrados temporalmente por volumen de tráfico.
      </p>

      <ul className="mt-7 space-y-6" data-id="element-118" data-mp="8f7wjikukiio">
        {comments.map(comment => <li key={comment.id} className="flex gap-3" data-id="element-119" data-mp="3kc4iifm1v5k">
            <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full font-sans text-sm font-semibold text-white" style={{
          backgroundColor: comment.avatarColor
        }} aria-hidden="true" data-id="element-120" data-mp="1091nkc2z4tt4">
              {comment.initials}
            </span>
            <div className="min-w-0" data-id="element-121" data-mp="m87ersc0kqtx">
              <div className="rounded-lg bg-neutral-100 px-4 py-3" data-id="element-122" data-mp="mbd1j0x67gmh">
                <p className="font-sans text-sm font-semibold text-ink" data-id="element-123" data-mp="3bzvu97h2ovfv">{comment.name}</p>
                <p className="mt-1 font-serif text-[0.95rem] leading-relaxed text-ink" data-id="element-124" data-mp="36ygb5kyggz04">
                  {comment.body}
                </p>
              </div>
              <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 pl-1 font-sans text-xs text-ink-muted" data-id="element-125" data-mp="3df7zwzetxtmu">
                <span className="font-semibold text-[#1877f2]" data-id="element-126" data-mp="2zgi6btr7yc38">Me gusta</span>
                <span aria-hidden="true" data-id="element-127" data-mp="34ejp0dkqg9e6">·</span>
                <span className="font-semibold text-[#1877f2]" data-id="element-128" data-mp="34d8lmev793nl">Responder</span>
                <span aria-hidden="true" data-id="element-129" data-mp="2pouf9tykqx2a">·</span>
                <span data-id="element-130" data-mp="2po2oqxju3piv">{comment.time}</span>
                <span className="flex items-center gap-1 text-ink-muted" data-id="element-131" data-mp="2uhnmcohimhhj">
                  <ThumbsUpIcon className="h-3 w-3 fill-[#1877f2] text-[#1877f2]" aria-hidden="true" data-id="element-132" data-mp="2gph3uvqw3yex" />
                  {comment.likes}
                </span>
              </div>
            </div>
          </li>)}
      </ul>

      <p className="mt-7 text-center font-sans text-sm text-ink-muted" data-id="element-133" data-mp="26s2u1ezh27vl">
        Cargando más comentarios…
      </p>
    </section>;
}